import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { RateSummary } from '@zillow/zhl-rate-card';
import React from 'react';

var RateSummaryBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs,
      blockData = _ref.blockData;
    return /*#__PURE__*/React.createElement(RateSummary, _extends({}, blockData, attrs));
  },
  metadata: {
    name: 'zhl/zhl-rate-summary',
    title: 'ZHL Rate Summary',
    description: 'ZHL Rate Summary',
    icon: 'editor-table',
    category: 'more',
    keywords: ['zhl', 'loan', 'rate', 'summary'],
    attributes: {
      state: {
        type: 'string',
        control: 'text',
        default: 'CA',
        description: 'State to fetch rates for, use two letter abbreviation',
        label: 'State'
      },
      principal: {
        type: 'number',
        control: 'number',
        default: 275000,
        description: 'Principal amount to calculate rates for',
        label: 'Principal'
      }
    }
  },
  getBlockData: function getBlockData(_ref2) {
    return new Promise(function ($return, $error) {
      var attrs, principal, state, apiUrl, apiKey, _data$30YearFixedC, _data$30YearFixedC2, _data$30YearFixedC3, _data$15YearFixedC, _data$15YearFixedC2, _data$15YearFixedC3, _data$76ARMConform, _data$76ARMConform2, _data$76ARMConform3, response, data, transformedData;
      attrs = _ref2.attrs;
      principal = (attrs === null || attrs === void 0 ? void 0 : attrs.principal) || 275000;
      state = (attrs === null || attrs === void 0 ? void 0 : attrs.state) || null;
      apiUrl = process.env.ZHL_RATES_API_URL + ("/zhlRatePage/states/" + (state || 'CA'));
      apiKey = process.env.ZHL_RATES_API_KEY;
      var $Try_1_Catch = function (error) {
        try {
          console.error('Error fetching rate summary data:', error);
          return $return(null);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(fetch(apiUrl, {
          method: 'GET',
          headers: {
            apiKey: apiKey
          }
        })).then(function ($await_2) {
          try {
            response = $await_2;
            if (!response.ok) {
              throw new Error("HTTP error! status: " + response.status);
            }
            return Promise.resolve(response.json()).then(function ($await_3) {
              try {
                data = $await_3;
                transformedData = {
                  state: state,
                  principal: principal,
                  thirtyYearRate: (_data$30YearFixedC = data['30 Year Fixed Conforming']) === null || _data$30YearFixedC === void 0 ? void 0 : _data$30YearFixedC.rate,
                  thirtyYearApr: (_data$30YearFixedC2 = data['30 Year Fixed Conforming']) === null || _data$30YearFixedC2 === void 0 ? void 0 : _data$30YearFixedC2.apr,
                  thirtyYearPoints: (_data$30YearFixedC3 = data['30 Year Fixed Conforming']) === null || _data$30YearFixedC3 === void 0 ? void 0 : _data$30YearFixedC3.pointsPaid,
                  fifteenYearRate: (_data$15YearFixedC = data['15 Year Fixed Conforming']) === null || _data$15YearFixedC === void 0 ? void 0 : _data$15YearFixedC.rate,
                  fifteenYearApr: (_data$15YearFixedC2 = data['15 Year Fixed Conforming']) === null || _data$15YearFixedC2 === void 0 ? void 0 : _data$15YearFixedC2.apr,
                  fifteenYearPoints: (_data$15YearFixedC3 = data['15 Year Fixed Conforming']) === null || _data$15YearFixedC3 === void 0 ? void 0 : _data$15YearFixedC3.pointsPaid,
                  sevenYearArmRate: (_data$76ARMConform = data['7/6 ARM Conforming']) === null || _data$76ARMConform === void 0 ? void 0 : _data$76ARMConform.rate,
                  sevenYearArmApr: (_data$76ARMConform2 = data['7/6 ARM Conforming']) === null || _data$76ARMConform2 === void 0 ? void 0 : _data$76ARMConform2.apr,
                  sevenYearArmPoints: (_data$76ARMConform3 = data['7/6 ARM Conforming']) === null || _data$76ARMConform3 === void 0 ? void 0 : _data$76ARMConform3.pointsPaid
                };
                return $return(transformedData);
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }, $Try_1_Catch);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error);
      }
    });
  }
};
var RateSummaryBlock$1 = RateSummaryBlock;

export { RateSummaryBlock$1 as default };
